//import { solicitar_datos,solicitud_de_sso } from 'services/Api';
import { TOKEN_DE_ACCESO } from '../constantes';
import ClaseMetodoDeBusqueda from 'servicios/ClaseMetodoDeBusqueda';
import ClaseMetodoDeOrden from 'servicios/ClaseMetodoDeOrden';

export default class ServiciosGenericos{
    constructor(nombreDelModulo, solicitudAlAPI){
        this.nombreDelModulo=nombreDelModulo;
        this.metodoDeBusqueda = new ClaseMetodoDeBusqueda();
        this.iniciarMetodoDeBusqueda = new ClaseMetodoDeBusqueda();
        this.metodoDeOrden = new ClaseMetodoDeOrden();
        this.iniciarMetodoDeOrden = new ClaseMetodoDeOrden();
        this.solicitudAlAPI= solicitudAlAPI;
        this.esMetodoPublico = false;
        this.changeMethodPagination = false;
        this.methodNamePagination = ""; 
    }

    setearMetodoPublico(esMetodoPublico){ this.esMetodoPublico=esMetodoPublico; };
    
    setearChangeMethodPagination({changePagination, methodName}){
        this.changeMethodPagination = changePagination;
        this.methodNamePagination = methodName;
    };

    setearPagina (pagina, tamanio) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO)) return Promise.reject("Acceso denegado");

        const parametrosDeBusqueda = this.metodoDeBusqueda ? `searchCriteria=${encodeURIComponent(JSON.stringify(this.metodoDeBusqueda.get()))}` : null;
        const parametrosDeOrden = this.metodoDeOrden ? `orderCriteria=${encodeURIComponent(JSON.stringify(this.metodoDeOrden.get()))}` : null;
        const url = `/${this.nombreDelModulo}/listar/${this.changeMethodPagination ? this.methodNamePagination : "registros"}/${pagina}/${tamanio}?${parametrosDeBusqueda}&${parametrosDeOrden}`;
        return this.solicitudAlAPI({ url, method: 'GET' });
    }

    obtenerRegistrosConParametros(nombreDelMetodo) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        const parametrosDeBusqueda = this.metodoDeBusqueda ? `searchCriteria=${encodeURIComponent(JSON.stringify(this.metodoDeBusqueda.get()))}` : null;
        const parametrosDeOrden = this.metodoDeOrden ? `orderCriteria=${encodeURIComponent(JSON.stringify(this.metodoDeOrden.get()))}` : null;
        const url = `/${this.nombreDelModulo}/${nombreDelMetodo ? nombreDelMetodo : "listar"}?${parametrosDeBusqueda}&${parametrosDeOrden}`
        return this.solicitudAlAPI({ url, method: 'GET' });
    }

    obtenerRegistrosPorURL(nombreDelMetodo, parametro) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        const parametrosDeBusqueda = this.metodoDeBusqueda ? `searchCriteria=${encodeURIComponent(JSON.stringify(this.metodoDeBusqueda.get()))}` : null;
        const parametrosDeOrden = this.metodoDeOrden ? `orderCriteria=${encodeURIComponent(JSON.stringify(this.metodoDeOrden.get()))}` : null;
        const url = parametro ? `/${this.nombreDelModulo}/${nombreDelMetodo}/${parametro}?${parametrosDeBusqueda}&${parametrosDeOrden}` : `/${this.nombreDelModulo}/${nombreDelMetodo}?${parametrosDeBusqueda}&${parametrosDeOrden}`;
        return this.solicitudAlAPI({ url, method: 'GET' });
    }

    obtenerRegistros() {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");
        return this.solicitudAlAPI({ url: `/${this.nombreDelModulo}/listar`, method: 'GET' });
    }

    getDocumentRegister(accion, nombreDelDocumento, registroID) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        return this.solicitudAlAPI({
            url: `/${this.nombreDelModulo}/${accion}/${nombreDelDocumento}/${registroID}`,
            method: 'GET'
        });
    }

    listarRegisterPublic() { return this.solicitudAlAPI({ url: `/${this.nombreDelModulo}/listar`, method: 'GET' }); }

    nuevoRegistro(nombreDelMetodo, datosAGuardar) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        return this.solicitudAlAPI({
            url: `/${this.nombreDelModulo}/${nombreDelMetodo ? nombreDelMetodo : "crear"}`,
            method: 'POST',
            body: JSON.stringify(datosAGuardar)
        });
    }

    nuevoRegistroPublico(datosAGuardar) {
        return this.solicitudAlAPI({
            url: `/${this.nombreDelModulo}/crear`,
            method: 'POST',
            body: JSON.stringify(datosAGuardar)
        });
    }

    actualizarRegistro(nombreDelMetodo, datosActualizar) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        return this.solicitudAlAPI({
            url: `/${this.nombreDelModulo}/${nombreDelMetodo ? nombreDelMetodo : "editar"}`,
            method: 'PUT',
            body: JSON.stringify(datosActualizar)
        });
    }

    eliminarRegistro(parametros) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        return this.solicitudAlAPI({ url: `/${this.nombreDelModulo}/eliminar/${parametros.id}`, method: 'DELETE' });
    }

    habilitarRegistro(parametros) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        return this.solicitudAlAPI({ url: `/${this.nombreDelModulo}/enable/${parametros.id}`, method: 'PATCH' });
    }

    deshabilitarRegistro(parametros) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        return this.solicitudAlAPI({ url: `/${this.nombreDelModulo}/disable/${parametros.id}`, method: 'PATCH' });
    }

    obtenerRegistrosPublicos(nombreDelMetodo) {
        const parametrosDeBusqueda = this.metodoDeBusqueda ? `searchCriteria=${encodeURIComponent(JSON.stringify(this.metodoDeBusqueda.get()))}` : null;
        const parametrosDeOrden = this.metodoDeOrden ? `orderCriteria=${encodeURIComponent(JSON.stringify(this.metodoDeOrden.get()))}` : null;
        const url = `/${this.nombreDelModulo}/${nombreDelMetodo}?${parametrosDeBusqueda}&${parametrosDeOrden}`
        return this.solicitudAlAPI({ url, method: 'GET' });
    }

    patchPersonalizado(nombreDelMetodo, datos) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        return this.solicitudAlAPI({
            url: "/"+this.nombreDelModulo+"/"+nombreDelMetodo,
            method: 'PATCH',
            body: JSON.stringify(datos)
        });
    }

    patchPersonalizadoConMetodos(action, nombreDelMetodo, nombreDelMetodoTwo, data, tipoMetodo) {
        if(!localStorage.getItem(TOKEN_DE_ACCESO) && !this.esMetodoPublico) return Promise.reject("Acceso denegado");

        return this.solicitudAlAPI({
            url: `/${this.nombreDelModulo}/${action}/${nombreDelMetodo}/${nombreDelMetodoTwo ? nombreDelMetodoTwo : ""}`,
            method: tipoMetodo,
            body: JSON.stringify(data)
        });
    }

    customGETpublic(methodName) {
        let parametrosDeBusqueda =    (this.metodoDeBusqueda!== undefined)   ? "searchCriteria="+encodeURIComponent(JSON.stringify(this.metodoDeBusqueda.get())) : null;
        let parametrosDeOrden =     (this.metodoDeOrden!== undefined)    ? "orderCriteria="+encodeURIComponent(JSON.stringify(this.metodoDeOrden.get())) : null;
        let url = "/"+this.nombreDelModulo+"/"+methodName+"?"+parametrosDeBusqueda+"&"+parametrosDeOrden;
        return this.solicitudAlAPI({
            url: url,
            method: 'GET'
        });
    }
}

